var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-5 mt-5 mb-5 bg-light rounded form-container",attrs:{"fluid":"sm"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }